import React from "react";
import Chart from "react-apexcharts";

const QueryWorkloadChart = () => {
  const data = [
    {
      user: "M. Patil",
      answered: 252,
      closed: 0,
    },
    {
      user: "N. Gupta",
      answered: 0,
      closed: 164,
    },
    {
      user: "R. Sharma",
      answered: 0,
      closed: 148,
    },
    {
      user: "Fernandes",
      answered: 0,
      closed: 145,
    },
    {
      user: "A. Joshi",
      answered: 115,
      closed: 0,
    },
    {
      user: "D. Shah",
      answered: 118,
      closed: 0,
    },
    {
      user: "S. Kulkarni",
      answered: 0,
      closed: 8,
    },
    {
      user: "V. Menon",
      answered: 0,
      closed: 8,
    },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: true,
        borderRadius: 4,
        barHeight: "70%",
      },
    },

    colors: [
      "#7c3aed", // Answered
      "#16a34a", // Closed
    ],

    dataLabels: {
      enabled: false,
    },

    legend: {
      position: "top",
      horizontalAlign: "center",
      fontSize: "13px",
      markers: {
        width: 12,
        height: 12,
      },
    },

    stroke: {
      width: 0,
    },

    xaxis: {
      categories: data.map((item) => item.user),
      min: 0,
      max: 300,
      tickAmount: 6,
    },

    grid: {
      borderColor: "#e2e8f0",
    },

    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  const series = [
    {
      name: "Answered",
      data: data.map((item) => item.answered),
    },
    {
      name: "Closed",
      data: data.map((item) => item.closed),
    },
  ];

  return (
    <>
      <div className="p-3">
        <Chart options={options} series={series} type="bar" height={220} />
      </div>
    </>
  );
};

export default QueryWorkloadChart;
